var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  stroke: "#fff",
  strokeWidth: 2,
  d: "M21.13 13.077 29.95 2.646 31.34 1h-4.824l-.3.354-7.228 8.55-5.715-8.464-.297-.44H3.118l1.053 1.56 9.337 13.827-9.272 10.967L2.846 29H7.67l.3-.354 7.68-9.086 6.077 9 .297.44h9.858l-1.053-1.56zm-4.437 1.5L9.9 4.69h.962l6.051 8.81.99 1.439 7.178 10.448h-.962l-6.261-9.114-.176-.257-.99-1.44Z"
})));
export { SvgTwitterStroke as ReactComponent };
export default __webpack_public_path__ + "static/media/twitterStroke.e3cee07c.svg";